import React from 'react';
import adalabsLogo from '../adalabs_logo_2.webp';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm text-gray-300">
              © 2025 DDQ ECP. All rights reserved.
            </p>
          </div>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm">
              Terms of Service
            </a>
            <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm">
              Contact
            </a>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-gray-700 flex justify-center items-center">
          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-300">Powered by</span>
            <img 
              src={adalabsLogo} 
              alt="Adalabs Logo" 
              className="h-6 w-auto"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 